// src/pages/ContactPage.jsx
import React from "react";
import Hero from "../components/hero/Hero";
import notifHero from "../assets/images/notifHero.png";
import Footer from "../components/footer/Footer";
import { FaPhone, FaEnvelope, FaBuilding } from "react-icons/fa";

const ContactPage = () => {
  return (
    <>
      <Hero
        title="Butuh bantuan atau ingin bertanya seputar layanan kami?"
        subtitle="Silakan hubungi kami melalui form di bawah ini atau lewat kontak yang tersedia. Kami siap mendengar Anda!."
        align="left"
        imageHero={notifHero}
      />

      <div className="section-shell section-band px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <span className="section-eyebrow mb-3">Hubungi kami</span>
          <h2 className="section-title">
            Kami percaya, komunikasi yang baik adalah{" "}
            <span className="font-bold text-[#2458d3]">
              awal dari solusi terbaik
            </span>
          </h2>
        </div>

        {/* Kontak Info & Peta */}
        <div className="container mx-auto flex flex-col lg:flex-row gap-8 items-stretch">
          {/* Informasi Kontak */}
          <div className="lg:w-1/3 w-full space-y-6">
            {/* Telepon */}
            <a
              href="tel:+6281111181888"
              className="modern-card flex items-start gap-4 p-5 focus:outline-none focus:ring-4 focus:ring-blue-100 animate-fadeInUp"
            >
              <div className="icon-tile mt-1">
                <FaPhone className="text-[#3f6fe5] w-6 h-6" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900">Telephone</h3>
                <p className="text-slate-600">0811-1118-1888</p>
              </div>
            </a>

            {/* Email */}
            <a
              href="mailto:cs@tokomikro.id"
              className="modern-card flex items-start gap-4 p-5 focus:outline-none focus:ring-4 focus:ring-blue-100 animate-fadeInUp"
              style={{ animationDelay: "0.1s" }}
            >
              <div className="icon-tile mt-1">
                <FaEnvelope className="text-[#3f6fe5] w-6 h-6" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900">Email</h3>
                <p className="text-slate-600">cs@tokomikro.id</p>
              </div>
            </a>

            {/* Kantor (Link ke Google Maps) */}
            <a
              href="https://maps.app.goo.gl/W2Nkd6gBtLsqfbmC9"
              target="_blank"
              rel="noopener noreferrer"
              className="modern-card flex items-start gap-4 p-5 focus:outline-none focus:ring-4 focus:ring-blue-100 animate-fadeInUp"
              style={{ animationDelay: "0.2s" }}
              aria-label="Buka lokasi kantor di Google Maps"
            >
              <div className="icon-tile mt-1">
                <FaBuilding className="text-[#3f6fe5] w-6 h-6" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900">Kantor</h3>
                <p className="text-sm leading-7 text-slate-600">
                  Jl. Kemang Raya No.4, RT.11/RW.1,
                  <br />
                  Bangka, Kec. Mampang Prpt., Kota Jakarta Selatan,
                  <br />
                  Daerah Khusus Ibukota Jakarta 12730
                </p>
              </div>
            </a>
          </div>

          {/* Peta Google Maps */}
          <div
            className="modern-card lg:w-2/3 w-full min-h-[420px] overflow-hidden animate-fadeInUp"
            style={{ animationDelay: "0.3s" }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d507655.4831248626!2d106.81207!3d-6.256029!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f1792b356e69%3A0x708ade3564081eee!2sGraha%20Kapital%201!5e0!3m2!1sen!2sus!4v1762400349242!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Lokasi Kantor Graha Kapital"
              className="rounded-xl"
            ></iframe>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;
